import { render, staticRenderFns } from "./PopupNoticeList.vue?vue&type=template&id=4fa46ee8"
import script from "./PopupNoticeList.vue?vue&type=script&lang=js"
export * from "./PopupNoticeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports